import { createSlice } from '@reduxjs/toolkit'
import { createAsyncActions } from '@/utils/sagas'

const initialState = {
  isFetching: false,
  hasInitialized: false,
  error: null,
  items: {}, // keyed by expert.id
}

export const fetchExpertsProspects = createAsyncActions('experts/list')

const expertsListSlice = createSlice({
  name: 'expertsList',
  initialState,
  extraReducers: ({ addCase }) => {
    addCase(fetchExpertsProspects.pending, (state) => {
      state.isFetching = true
      state.error = null
    })

    addCase(fetchExpertsProspects.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items = payload.items
      state.hasInitialized = true
    })

    addCase(fetchExpertsProspects.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
      state.hasInitialized = true
    })
  },
})

export const reducer = expertsListSlice.reducer
